module.exports = __webpack_public_path__ + "static/media/xinghai.b52cc6bd.jpg";